import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
import DOMPurify from "isomorphic-dompurify";

const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "h1-mobile",
            "h1-tablet",
            "h1-desktop",
            "h2-mobile",
            "h2-tablet",
            "h2-desktop",
            "h3-mobile",
            "h3-tablet",
            "h3-desktop",
            "h4-mobile",
            "h4-tablet",
            "h4-desktop",
            "h5-mobile",
            "h5-tablet",
            "h5-desktop",
            "blog-h2-mobile",
            "blog-h2-tablet",
            "blog-h2-desktop",
            "special-h1-desktop",
            "special-h1",
            "special-h2",
            "special-h3",
            "special-h4",
            "special-h5",
            "small-special-heading",
            "medium-special-heading",
            "large-special-heading",
            "paragraph-small",
            "paragraph-medium",
            "paragraph-large",
            "paragraph-xlarge",
            "paragraph-xxlarge",
            "span-small",
            "span-medium",
            "span-large",
            "span-xlarge",
            "span-xxlarge",
            "footer-title",
            "footer-links",
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}

export const sanitizeHTML = (content: string) => {
  return {
    __html: DOMPurify.sanitize(content, {
      ADD_ATTR: ["target"],
      ADD_TAGS: ["iframe"],
    }),
  };
};

export const shimmer = (w: number, h: number) => `
  <svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <linearGradient id="g">
        <stop stop-color="#333" offset="20%" />
        <stop stop-color="#222" offset="50%" />
        <stop stop-color="#333" offset="70%" />
      </linearGradient>
    </defs>
    <rect width="${w}" height="${h}" fill="#333" />
    <rect id="r" width="${w}" height="${h}" fill="url(#g)" />
  </svg>`;

export const toBase64 = (str: string) =>
  typeof window === "undefined"
    ? Buffer.from(str).toString("base64")
    : window.btoa(str);
